import { render, staticRenderFns } from "./EliminarCuenta.vue?vue&type=template&id=a868ad8c&scoped=true"
import script from "./EliminarCuenta.vue?vue&type=script&lang=ts"
export * from "./EliminarCuenta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a868ad8c",
  null
  
)

export default component.exports